import Vue from '@/setup'

import { DEFAULT_DELAY_TIME } from '@/config/constants'
import { ValidatorsUtil } from '@/utils/Validators'

const types = {
  FIXED: ['FIXED_LINE_OR_MOBILE', 'FIXED_LINE', 'UAN'],
  MOBILE: ['MOBILE', 'FIXED_LINE_OR_MOBILE']
}

export const ValidatorsHelper = {
  ...ValidatorsUtil,

  validatePhoneNumber(value, type = false) {
    if (!value) return true

    return new Promise((resolve, _reject) => {
      Vue.prototype.$backend.validation
        .validatePhoneNumber(value, type)
        .then(response => {
          const data = response?.data
          const valid = data?.valid
          const correctType = (!type || types[type].includes(data?.type))

          if (valid && correctType) {
            return resolve(true)
          } else if (valid && !correctType) {
            return resolve(false)
          } else {
            return resolve(false)
          }
        })
        .catch(() => resolve(false))
    })
  },

  isMobileNumber(value) {
    return this.validatePhoneNumber(value, 'MOBILE')
  },

  isValidPhoneNumber(value) {
    return this.validatePhoneNumber(value)
  },

  /**
   * Rejects if invalid after pending finished
   *
   * @param {VuelidateState} validator
   * @returns {Promise}
   */
  pendingValidate(validator, _field = '$invalid') {
    return new Promise((resolve, reject) => {
      if (validator.$anyError || !validator.$pending) {
        return validator[_field] ? reject(validator) : resolve(validator)
      }
      const poll = setInterval(() => {
        if (!validator.$pending) {
          clearInterval(poll)
          return validator[_field] ? reject(validator) : resolve(validator)
        }
      }, DEFAULT_DELAY_TIME / 5)
    })
  }
}
